import PropTypes from 'prop-types';
import React from 'react';

import styles from './JobStatusOpenFilter.module.scss';

const JobStatusOpenFilter = ({ isActive, onFilterToggle }) => {
  const toggleSwitchClass = [
    styles.toggleSwitch,
    isActive ? styles.toggleSwitchOn : '',
  ].join(' ');

  return (
    <div className={toggleSwitchClass} onClick={onFilterToggle}>
      <div className={styles.toggleSwitchContainer}></div>
      <div className={styles.toggleSwitchContainer}></div>
    </div>
  );
};

JobStatusOpenFilter.propTypes = {
  isActive: PropTypes.bool,
  onFilterToggle: PropTypes.func,
};

export default JobStatusOpenFilter;
